import Comment, { CommentType } from "@/features/Comments/Comment";

export default class CommentRequestModel {
    id: string | null = null;
    body: string = "";
    commentType: CommentType = null!;
    documentMetadataIDs: string[] = [];
    toDataModel() {
        const comment = new Comment();
        comment.id = this.id;
        comment.body = this.body;
        comment.commentType = this.commentType;
        return comment;
    }
}

export class ScoreCommentRequestModel extends CommentRequestModel {
    scoreID: string = "";
}

export class IncidentCommentRequestModel extends CommentRequestModel {
    incidentID: string = "";
}

export class CommentContainer {
    scoreComment: ScoreCommentRequestModel | null = null;
    incidentComment: IncidentCommentRequestModel | null = null;
}
